import { render, staticRenderFns } from "./Traduction.vue?vue&type=template&id=0a5c6ea5&"
import script from "./Traduction.vue?vue&type=script&lang=js&"
export * from "./Traduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports